import React, { Component } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import './loginstyle.css';
import {

  Container,

  Button,
  Row,
  Col,

} from "reactstrap";

import AuthService from "services/auth.service";

const required = value => {
  if (!value) {
    return (
      <div className="alert alert-danger alertlogin" role="alert">
        This field is required!
      </div>
    );
  }
};

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);

    this.state = {
      username: "demo.user",
      password: "hello123",
      loading: false,
      message: ""
    };
  }

  onChangeUsername(e) {
    this.setState({
      username: e.target.value
    });
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value
    });
  }

  handleLogin(e) {
    e.preventDefault();

    this.setState({
      message: "",
      loading: true
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {
      AuthService.login(this.state.username, this.state.password)
      
      this.props.history.push("/");
      window.location.reload();
      
    }

  }

  render() {
    return (
      <div id="ContentBody" className="clearfix">
		  <Row className="justify-content-center align-items-center">


      <div id="login-container">
  
  
		  <Row className="justify-content-center align-items-center">

  
      <img id="login-logo" title="CompanyName"  src={require('./hd-logo.png')}  alt={"CompanyName"} style={{width:"20%"}} />   
      </Row>
		  <Row className="justify-content-center align-items-center">

        <h2><span className="text_1">Welcome To Ticketing System Demo Version</span>
        	<span className="text_2">We are Delighted To Be at Your Service</span>
        <span className="text_3">Thank You For Placing Your Trust On Us</span></h2>
        </Row>
        <Row className="justify-content-center align-items-center">

			<h1>Please Login</h1>
      </Row>

      <Form
            onSubmit={this.handleLogin}
            ref={c => {
              this.form = c;
            }}
          >

            <div className="form-group">

            <label  className="cstmlabl">

              <Input
              className='cstminpt'

                type="text"
                name="username"
                value={this.state.username}
                onChange={this.onChangeUsername}
                validations={[required]}
                placeholder="Username" 
              /> 
</label>
<br></br>
            </div>

            <div className="form-group">
              <Input
              className='cstminpt'
                type="password"
                name="password"
                value={this.state.password}
                onChange={this.onChangePassword}
                validations={[required]}
                placeholder="Password"
              />
            </div>

            <div className="form-group">
              <button
                className="loginbtn"
                disabled={this.state.loading}
              >
                {this.state.loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                <span> Login</span>
              </button>
            </div>

            {this.state.message && (
              <div className="form-group">
                <div className="alert alert-danger alertlogin" role="alert">
                  {this.state.message}
                </div>
              </div>
            )}
            <CheckButton
              style={{ display: "none" }}
              ref={c => {
                this.checkBtn = c;
              }}
            />
          </Form>

           
      </div>
      </Row>

    </div>
    );
  }
}
